module.exports = __webpack_public_path__ + "img/yoututor_2.8edbd790.jpg";